import { timer } from 'rxjs';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';

@Component({
  selector: 'app-anios',
  templateUrl: './anios.component.html',
  styleUrls: ['./anios.component.css']
})
export class AniosComponent {


  anios: any[] = [];
  searchTerm: string = '';
  originalAnios: any[] = [];
  loading: boolean = true;
  mensajeAreas: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private filtrarProyectosService: FiltrarProyectosService) { }

  ngOnInit() {
    this.verificacionUsuario();
  }

  verificacionUsuario(){
    const { token } = this.filtrarProyectosService.validacionUsuarios();

    timer(1).subscribe(() => {
      this.requestsService.getYears(token).subscribe(
        (data: any) => {
          // Convertimos los nombres de las claves antes de asignarlas
          this.anios = data.map(( item : any ) => ({
            ...item,
            anio: item.Año,  // Convertir "Año" a "anio"
            id_anio: item.id_Año,  // Convertir "id_Año" a "id_anio"
          }));
      
          this.originalAnios = [...this.anios]; // Clonamos los datos procesados
          this.loading = false;
      
          if (this.anios.length === 0) {
            this.mensajeError(`No se tienen áreas de facturación que mostrar.`);
          }
      
          console.log("Datos modificados:", this.anios);
      });
    });

  }

  search() {
    if (this.searchTerm) {
      this.buscador();
    } else {
      this.anios = [...this.originalAnios]; // Restaurar la lista completa
    }
  }
  
  buscador() {
    const term = this.searchTerm ? this.searchTerm.trim() : '';
    this.anios = this.originalAnios.filter(anio => anio.toString().includes(term));
    if (this.anios.length === 0) {
      this.mensajeError(`Con los criterios "${this.searchTerm}", no encontramos ninguna coincidencia.`);
    }
  }

  mensajeError(mensaje:string){
    this.mensajeAreas = mensaje;
  }

  editar(op: any, area: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(area);
    this.router.navigate(['/aniosD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/aniosD', opE]);
  }


}
